// Layout/MainLayout.jsx

import React, { useState } from "react";
import Sidebar from "../sidebar/Sidebar";
import style from '../mainlayout/Mainlayout.css'

const MainLayout = ({ children }) => {
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setSidebarVisible((prev) => !prev);
  };

  return (
    <div className="flex h-screen overscroll-none overflow-hidden main text-black relative">
  {/* Sidebar Toggle Button */}
  <button
    onClick={toggleSidebar}
    className="absolute top-4 left-4 z-50 sidebar  text-white px-3 py-1 rounded transition"
  >
    {isSidebarVisible ? "<" : ">"}
  </button>

  {/* Sidebar */}
  {isSidebarVisible && (
    <div className="transition-all duration-300 w-20 h-full overflow-hidden">
      <Sidebar className="h-full bg-orange-200 p-4" />
    </div>
  )}

  {/* Main Content */}
  <div
    className={`transition-all duration-300 ease-in-out ${
      isSidebarVisible ? "ml-10" : "ml-0"
    } flex-1 p-5 pt-10 overflow-auto`}
  >
    {children}
  </div>
</div>

  );
};

export default MainLayout;
